const getLanguage = state => state.view.lang || 'en';

export default getLanguage;
